// @flow
import type { FluxStandardAction } from 'flux-standard-action';
import { API_CALL } from './apiMiddleware';
import type { ExtractReturn } from '../types';

export const NEWSLETTER_URI_GET = 'gdpr/auth/NEWSLETTER_URI_GET';

const getNewsletterUri: FluxStandardAction<> = () => ({
  type: NEWSLETTER_URI_GET,
  meta: {
    [API_CALL]: 'getNewsletterUri'
  }
});

export type Actions = ExtractReturn<typeof getNewsletterUri>;

export type State = {
  +isFetching?: boolean,
  +error?: boolean,
  +result?: {},
  +newsletterUri?: {}
};

export default function reducer(
  state: State = {},
  action: Actions | FluxStandardAction<>
): State {
  switch (action.type) {
    case NEWSLETTER_URI_GET:
      return action.error
        ? {
            ...state,
            isFetching: false,
            error: action.error
          }
        : { newsletterUri: action.payload };
    case `${NEWSLETTER_URI_GET}_PENDING`:
      return {
        ...state,
        isFetching: true,
        error: false
      };
    default:
      return state;
  }
}

const selectNewsletterUri = (state: State) => state.newsletterUri || {uri: ''};

export const actions = {
  getNewsletterUri
};
export const selectors = {
  selectNewsletterUri
};
